import { format, isSameMonth, isSameYear, parseISO } from "date-fns";
import { DocumentTaxonomyExtraction } from "@common/types/financialDocument";
import { fullDateFullYearFormat } from "@common/helpers/date";
import { addTimeZoneOffset } from "@helpers/date";

function toDate(value: Date | string | null | undefined): Date | null {
    if (!value) {
        return null;
    }
    const date = value instanceof Date ? value : parseISO(value);
    if (isNaN(date.getTime())) {
        return null;
    }
    return addTimeZoneOffset(date);
}

function formatPeriod(
    startDate: Date | null,
    endDate: Date | null,
): string | null {
    if (startDate && endDate) {
        if (startDate.getTime() === endDate.getTime()) {
            return format(startDate, fullDateFullYearFormat);
        }
        if (isSameMonth(startDate, endDate)) {
            return `${format(startDate, "MMM d")} – ${format(endDate, "d, yyyy")}`;
        }
        if (isSameYear(startDate, endDate)) {
            return `${format(startDate, "MMM d")} – ${format(endDate, fullDateFullYearFormat)}`;
        }
        return `${format(startDate, fullDateFullYearFormat)} – ${format(endDate, fullDateFullYearFormat)}`;
    }

    if (startDate) {
        return format(startDate, fullDateFullYearFormat);
    }

    if (endDate) {
        return format(endDate, fullDateFullYearFormat);
    }

    return null;
}

export function formatDocumentPeriod(
    extraction: DocumentTaxonomyExtraction | null | undefined,
): string | null {
    if (!extraction) {
        return null;
    }
    const start = toDate(extraction.periodStartDate);
    const end = toDate(extraction.periodEndDate);
    return formatPeriod(start, end);
}
